<template>
  <div>
    <!-- Tabla de productos -->
    <div class="panel">

      <b-table
        :data="products"
        :loading="isLoadingTable"

        paginated
        backend-pagination
        :per-page="perPage"
        :total="total"
        @page-change="onPageChange"

        backend-sorting
        :default-sort="orderField"
        :default-sort-direction="orderDir"
        @sort="onSort"

        class="w-full"
        striped
        bordered
        icon-pack="fas"
        detailed
        detail-key="code"
        :show-detail-icon="showDetailIcon" scrollable>
        <template>

          <b-table-column field="store_products.code" :label="$t('code')" sortable v-slot="props">
            {{ props.row.code }}
          </b-table-column>

          <b-table-column field="store_products.name" :label="$t('name')" sortable v-slot="props">
            {{ props.row.product_name }}
          </b-table-column>

          <b-table-column field="type_product" :label="$t('type_product')" v-slot="props">
            {{ getValueExtrafield(props.row.product.extrafields, 'tipo_producto') }}
          </b-table-column>

          <b-table-column field="material" :label="$t('material')" v-slot="props">
            {{ getValueExtrafield(props.row.product.extrafields, 'material') }}
          </b-table-column>

          <b-table-column field="main_diameter" :label="$t('main_diameter')" v-slot="props">
            {{ getValueExtrafield(props.row.product.extrafields, 'diametro_principal') }}
          </b-table-column>

          <b-table-column field="comment_single" :label="$t('comment_single')" v-slot="props">
            {{ getValueExtrafield(props.row.product.extrafields, 'comentario') }}
          </b-table-column>

          <b-table-column field="purpose" :label="$t('purpose')" v-slot="props">
            {{ getValueExtrafield(props.row.product.extrafields, 'proposito') }}
          </b-table-column>

          <b-table-column field="inventories.stock" :label="$t('stock')" sortable v-slot="props">
            {{ props.row.stock }}
          </b-table-column>

          <b-table-column field="warehouses.name" :label="$t('storehouse')" sortable v-slot="props">
            {{ getWarehouses(props.row.warehouses) }}
          </b-table-column>

        </template>
        <template #detail="props">

          <b-collapse
            class="card mb-2"
            style="border: 1px solid #5577BB;"
            animation="slide"
            v-for="(warehouse, index) of props.row.warehouses"
            :key="warehouse.id+'-'+props.row.product_id"
            :open="isOpen == warehouse.product_id+'-'+props.row.product_id"
            @open="isOpen = warehouse.product_id+'-'+props.row.product_id"
            :aria-id="'contentIdForA11y5-' + index">
            <template #trigger="props">
                <div
                    class="card-header"
                    style="background-color: #5577BB"
                    role="button"
                    :aria-controls="'contentIdForA11y5-' + index"
                    :aria-expanded="props.open"
                >
                    <p class="card-header-title" style="color: white;">
                        {{ $t('storehouse') + ': ' + warehouse.name }}
                        <span class="ml-20">{{ $t('stock') }}: {{ warehouse.stock }}</span>
                        <span class="ml-20">{{ $t('stock_min') }}: {{ warehouse.stock_min }}</span>
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>
            <div class="card-content">
                <div class="content">
                  <div v-if="warehouse.purchases.length > 0">
                    <b-table :data="warehouse.purchases" :loading="isLoadingTable" class="w-full" striped bordered
                      icon-pack="fas" scrollable>
                      <template>
                        <b-table-column field="custom_code" :label="$t('code')" sortable v-slot="props">
                          {{ formatValue(props.row.custom_code) }}
                        </b-table-column>

                        <b-table-column field="provider" :label="$t('provider')" sortable v-slot="props">
                          {{ formatValue(props.row.inventory.provider.name) }}
                        </b-table-column>

                        <b-table-column field="quantity_in" :label="$t('incoming_quantity')" class="text-center" sortable v-slot="props">
                          {{ formatValue(props.row.qty) }}
                        </b-table-column>

                        <b-table-column field="price" :label="$t('unit_price')" class="text-center" sortable v-slot="props">
                          {{ formatValue(props.row.unit_price )}}
                        </b-table-column>

                        <b-table-column field="price" :label="$t('amount')" class="text-center" sortable v-slot="props">
                          {{ formatValue(props.row.price )}}
                        </b-table-column>

                        <b-table-column field="quantity_out" :label="$t('outgoing_quantity')" class="text-center" sortable v-slot="props">
                          {{ totalOuts(props.row, warehouse) }}
                        </b-table-column>

                        <b-table-column field="price" :label="$t('stock')" class="text-center" sortable v-slot="props">
                          {{ calculateStock(props.row, warehouse)}}
                        </b-table-column>

                        <b-table-column field="warehouse" :label="$t('storehouse')" sortable v-slot="props">
                          {{ props.row.warehouse? props.row.warehouse.name:"-" }}
                        </b-table-column>

                        <b-table-column field="delivery_note" :label="$t('delivery_note')" sortable v-slot="props">
                          {{ formatValue(props.row.delivery_note )}}
                        </b-table-column>
                        <b-table-column field="date_purchase" :label="$t('date_purchase')" sortable v-slot="props">
                          {{ props.row.date_purchase ? moment(props.row.date_purchase	).format("DD/MM/YYYY") : "-" }}
                        </b-table-column>

                      </template>
                    </b-table>
                  </div>

                  <div v-else class="text-center py-4">
                    {{ $t('no_results') }}
                  </div>
                </div>
            </div>
          </b-collapse>
        </template>

        <template #empty>
          <div class="has-text-centered">{{ $t('no_results') }}</div>
        </template>
      </b-table>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from 'axios'
  import moment from 'moment'
  import { parseQuantity } from './helpers.js'

  export default {

    components: {

    },

    props: {
      projectId: {type: Number, require: true },
    },

    computed: {
      ...mapGetters({
        company: "app/company",
      }),

      filters() {
        let filters = {
          'order_field': this.orderField,
          'order_dir': this.orderDir,
          'perPage': this.perPage,
          'page': this.page,
        }

        return filters
      }
    },

    data: function() {
      return {
        isLoadingTable: true,
        products: [],

        perPage: 25,
        orderField: 'store_products.name',
        orderDir: 'asc',
        page: 1,
        last: 1,
        total: 0,

        applyFilters: { },
        showDetailIcon: true,

        isOpen: null, // para saverque collapse esta abierto
      }
    },

    created() {
      this.getInventary()
    },

    methods: {

      async getInventary(filters = null) {
        this.isLoadingTable = true
        this.products = []

        let params = { ...this.filters }

        if( filters != null )
          params = { ...this.filters, ...filters }

        params['filter_project_id'] = this.projectId

        const {data} = await axios.get(`/api/v2/store-inventories`, {params: params})
        if (data && data.success) {
          this.products = data.products
          this.last = data.lastPage;
          this.total = data.total;
          this.isLoadingTable = false
        }
      },

      onSort(field, order) {
        this.companyId = this.company.id
        this.orderField = field
        this.orderDir = order
        this.getInventary(this.applyFilters )
      },

      onPageChange(page) {
        this.page = page
        this.getInventary(this.applyFilters)
      },

      reload(arg = {}) {
        this.page = arg.page || 1
        delete arg.page
        // this.applyFilters = { ...arg, ...this.filters }
        this.applyFilters = { ...arg }
        this.getInventary(this.applyFilters);
      },

      async editButtonClicked(entity) {
        this.$emit('epc-edit', entity)
      },

      deleteButtonClicked(materialId, materialName) {
        this.$dialog.confirm({
          title: this.$t('delete'),
          message: this.$t('delete_confirm_text', ['el material', materialName]),
          confirmText: this.$t('delete') + ' ' + this.$t('material'),
          type: 'is-danger',
          hasIcon: true,
          onConfirm: async () => {
            let url = '/api/v2/store-inventory/' + materialId + '/delete'
            const {data} = await axios.post(url)
            if (data && data.success) {
              this.$notify.success('success_deleting_generic')
              this.getInventary()
            } else {
              this.$notify.error(data.error)
            }
          }
        })
      },

      archiveClass(value) {
        return value ? "cursor-pointer flex text-yellow-dark" : "cursor-pointer flex text-blue"
      },

      handleSelect(newRow, oldRow) {
        this.$emit('update:template', newRow);
      },

      clearSelected() {
        this.rowSelected = null
      },

      showQuantity(quantity) {
        return parseQuantity(quantity);
      },

      getValueExtrafield(extrafields, fieldCode) {
        let field = extrafields.find(function (el) {
          return el.code == fieldCode;
        });

        let valueField = '';
        if (field) {
          switch (fieldCode) {
            case 'tipo_producto':
            case 'ubicacion_almacen':
            case 'proposito':
              valueField = field.value ? field.value.name : null;
              break;

            case 'diametro_principal':
            case 'diametro_secundario':
            case 'comentario':
              valueField = field.value_free;
              break;

            case 'material':
              valueField = field.value ? field.value.name : null;
              break;
          }
        }
        return valueField;
      },

      getWarehouses(warehouses) {
        let warehouseNames = warehouses.map(warehouse => {
          return warehouse.name;
        });
        return warehouseNames.join(", ");
      },

      formatValue(value) {
        return value ? value : "-";
      },

      totalOuts(row, warehouse) {
        let total = 0;
        if (warehouse?.outs) {
          let objs = warehouse.outs.filter(out => out.inventory_id == row.inventory_id && out.purchase_id == row.id);
          total = objs.reduce((acc, out) => {
            return acc + ( parseFloat(out.qty) || 0);
          }, 0);
        }
        return total;
      },

      calculateStock(row, warehouse) {
        let stock = row.qty - this.totalOuts(row, warehouse);
        return stock >= 0 ? stock : 0;
      },
    },

  };
</script>
